<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div class="row mb-3">
            <div class="col-12">
                <app-search (search)="search($event)"></app-search>
                <div id="table-wrapper">
                    <div id="table-scroll">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th><span>Naam</span></th>
                                    <th><span>Locatie</span></th>
                                    <th><span>Plaats</span></th>
                                    <th><span>Soort</span></th>
                                    <th><span>BRIN</span></th>
                                    <th><span>Vestigingscode</span></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let organisation of organisationList">
                                    <tr (click)="select(organisation)">
                                        <td>{{organisation['name']}}</td>
                                        <td>{{organisation['location']}}</td>
                                        <td>{{organisation['city']}}</td>
                                        <td>{{organisation['type']}}</td>
                                        <td>{{organisation['brin_number']}}</td>
                                        <td>{{organisation['department_number']}}</td>
                                        <td>
                                            <i class="bi bi-arrow-right-circle cursor-pointer p-3"></i>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>